class EngravingInputLinesAndAction extends HTMLElement {
  constructor() {
    super();
    this.engravingData = this.getEngravingData();
    this.currentProductEngravingOptions =
      this.engravingData?.currentProductEngravingOptions;
  }

  connectedCallback() {
    this.attachEventListeners();
    this.initializeEngraving();
  }

  disconnectedCallback() {
    this.removeEventListener("input", this.inputEventHandler.bind(this));
  }

  /**
   * Attaches event listeners for engraving interactions.
   */
  attachEventListeners() {
    document.addEventListener(
      "engravingTypeSelected",
      this.handleEngravingTypeSelected.bind(this)
    );

    this.addEventListener("input", this.inputEventHandler.bind(this));

    document.addEventListener("cartItemAddEngraving", (event) => {
      this.clearEngravingLines();
      const currentProductEngravingOptions =
        event.detail.currentProductEngravingOptions[0];
      this.renderEngravingLines(currentProductEngravingOptions.engravingLines);
    });

    document.addEventListener("cartItemEditEngraving", (event) => {
      this.clearEngravingLines();

      let currentProductEngravingOptions =
        event.detail.currentProductEngravingOptions[0];

      this.renderEngravingLines(currentProductEngravingOptions.engravingLines);
    });
  }

  /**
   * Handles input events on engraving fields and dispatches a custom event.
   * @param {Event} event - The input event.
   */
  inputEventHandler(event) {
    const input = event.target;
    const inputCustomEvent = new CustomEvent("engravingLineInput", {
      detail: {
        line: Number(input.name.split("engraving-line-")[1]),
        value: input.value,
      },
    });
    document.dispatchEvent(inputCustomEvent);
  }

  /**
   * Initializes engraving fields based on the default engraving option.
   */
  initializeEngraving() {
    const defaultOption = this.getDefaultEngravingOption();
    if (!defaultOption) return;

    this.renderEngravingLines(defaultOption.engravingLines);
  }

  /**
   * Handles the selection of an engraving type and updates the input fields.
   * @param {CustomEvent} event - The engraving type selection event.
   */
  handleEngravingTypeSelected(event) {
    const { engravingLines } = event.detail;
    this.renderEngravingLines(engravingLines);
  }

  /**
   * Updates the visibility of engraving input fields based on the selected option.
   * @param {number} engravingLines - The number of engraving lines to display.
   */

  renderEngravingLines(engravingLines) {
    this.querySelectorAll(".engraving-line-input").forEach((input) => {
      let line = Number(input.dataset.engravingLine);
      input.style.display = line <= engravingLines ? "block" : "none";
    });
  }

  /**
   * Clear all the input lines
   */
  clearEngravingLines() {
    this.querySelectorAll(".engraving-line-input").forEach(
      (input) => (input.value = "")
    );
  }

  /**
   * Retrieves engraving data from the DOM.
   * @returns {Object} Parsed engraving data.
   */
  getEngravingData() {
    return JSON.parse(
      document.querySelector("#engraving-options-data").textContent
    );
  }

  /**
   * Retrieves the default engraving option.
   * @returns {Object} Default engraving option.
   */
  getDefaultEngravingOption() {
    return this.currentProductEngravingOptions[0] || [];
  }
}
customElements.define(
  "engraving-input-lines-and-actions-component",
  EngravingInputLinesAndAction
);
